import { findLastIndex } from "lodash-es";

import type { GameWord } from "../Game";

export type GameAnswer = {
  correct: boolean;
  word: GameWord;
  solution: string;
};

/**
 * Get the current streak from a series of answers. A streak ends when the
 * player answers incorrectly.
 */
export const getStreak = (answers: GameAnswer[]) => {
  // use lodash because `Array.findLastIndex` is not supported by Chrome <96
  const lastIncorrectAnswer = findLastIndex(
    answers,
    (answer) => !answer.correct,
  );
  return answers.length - lastIncorrectAnswer - 1;
};

/**
 * Get the total points for a game. When the player answers correctly, they gain
 * points. When they skip a question, they lose points.
 */
export const getPoints = (answers: GameAnswer[]) => {
  return answers.reduce((points, answer) => {
    return answer.correct ? points + 10 : Math.max(0, points - 5);
  }, 0);
};

/**
 * Get the longest streak from a series of answers.
 */
export const getLongestStreak = (answers: GameAnswer[]) => {
  let currentStreak = 0;
  let longestStreak = 0;

  for (const answer of answers) {
    if (!answer.correct) {
      currentStreak = 0;
      continue;
    }

    currentStreak++;
    if (currentStreak > longestStreak) {
      longestStreak = currentStreak;
    }
  }

  return longestStreak;
};
